/*
 * @Author: chen cs
 * @Date: 2020-02-06 20:41:25
 * @LastEditors: GRANDSOFT\chenz-k chenz-k@glodon.com
 * @LastEditTime: 2023-09-25 15:36:13
 * @Description: file content
 */
import Vue from 'vue'
import Router from 'vue-router'
import model from './model'
import indexpage from './indexpage'
import space from './space'
import feedback from './feedback'
import upload from './upload'
import manage from './manage'
import database from './database'
import preview from './preview'
import share from './share'
import board from './board'
import project from './project'
import enterpriseShare from './enterprise-share'
import iframe from './iframe-menu'
import applications from './applications'
import iframePortal from './iframe-portal'
// import loadingBar from '@zjy/zjy-ui/lib/loading-bar'
// import {getCookie} from '@/assets/utils/CommonUtil'
// import store from '@/store'

// const routerPush = Router.prototype.push
// Router.prototype.push = function push (location) {
//   return routerPush.call(this, location).catch(error => error)
// }
// router文件夹下等index.js文件中写入
// 解决编程式路由往同一地址跳转时会报错的情况
const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace
// push
Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
// replace
Router.prototype.replace = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}

Vue.use(Router)

// const router = new Router({
//   // mode: 'history',
//   // base: process.env.BASE_URL,
//   routes: [
//     ...model,
//     ...indexpage,
//     ...space,
//     ...feedback,
//     ...upload,
//     ...manage,
//     ...database,
//     ...preview,
//     ...share,
//     ...board,
//     ...project,
//     ...enterpriseShare,
//     ...iframe,
//     ...applications
//   ]
// })

// const queryMenuList = async () => {
//   try {
//     return await store.dispatch('menus/queryMenuList')
//   } catch (e) {
//     return []
//   }
// }

// router.beforeEach(async (to, from, next) => {
//   loadingBar.start()
//   // if (to.meta.title) {
//   //   document.title = to.meta.title
//   // }
//   // if (to.meta.auth) {
//   //   // 获取菜单，拦截无权限路由
//   //   let menuList = store.state.menus.menuList
//   //   if (menuList.length === 0) {
//   //     menuList = await queryMenuList()
//   //   }
//   // } else {
//   //   next()
//   // }
//   const staticPage = ['/index', '/production', '/findAdmin', '/vip', '/privacy', '/agreement', '/404', '/401', '/login']
//   if (staticPage.includes(to.path)) {
//     next()
//   } else {
//     const role = getCookie('role')
//     const employeeRouterPath = ['/workbench', '/project', '/database', '/applications', '/enterprise', '/manage']
//     const adminRouterPath = ['/manage', '/preview']
//     // 管理员从成本大数据平台跳转进入时允许进入共享空间
//     if (+role === 1 && window.parent[0] && window.parent[0].name === 'dcost-web' && to.query.from && to.query.from === 'dcost') {
//       adminRouterPath.push('/enterprise')
//     }
//     if (to.matched.length) {
//       const rootPath = to.matched[0].path
//       if (['/upload', '/feedback', '/home', '/cfmcc'].includes(to.matched[0].path)) {
//         next()
//       } else if ((+role === 1 && !adminRouterPath.includes(rootPath)) || (+role === 5 && (employeeRouterPath.includes(rootPath) || to.path === '/board/no_permission')) || (+role === 4 && rootPath === '/manage')) {
//         next('/401')
//       } else {
//         next()
//       }
//     } else {
//       next('/404')
//     }
//   }
// })

// router.afterEach(to => {
//   loadingBar.end()
//   window.scrollTo(0, 0)
// })
const routes = [
  ...model,
  ...indexpage,
  ...space,
  ...feedback,
  ...upload,
  ...manage,
  ...database,
  ...preview,
  ...share,
  ...board,
  ...project,
  ...enterpriseShare,
  ...iframe,
  ...applications,
  ...iframePortal
]
export default routes
